export const defaultStartChatErrorPaneIconStyleProps = {
  display: "flex",
  order: 1,
  alignSelf: "auto",
  backgroundColor: "#FFFFFF",
  boxShadow: "#FFFFFF 0px 0px 0px 0px",
  margin: "0px 0px 0px 0px"
};